export default function TelematicsSerialNumberDirective($q, installationsService, packagesService, devicesService, gettextCatalog) {

  'ngInject';

  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, ctrl) {

      //prevent enter from submitting the form
      elm.on("keydown", function (ev) {
        if (ev.keyCode == 13) {

          if (!e) var e = window.event;

          e.cancelBubble = true;
          e.returnValue = false;

          e.preventDefault();
          e.stopPropagation();
          ctrl.$commitViewValue();
          scope.$apply(ctrl.$setTouched);
        }
      });

      elm.on("change blur", function (ev) {
        ctrl.$commitViewValue();
        scope.$apply(ctrl.$setTouched);

      });

      ctrl.$asyncValidators.telematicsserialnumber = function (modelValue /*, viewValue*/ ) {
        var deferred = $q.defer();
        var serialNumber = modelValue;

        scope.$emit("packagesRetrieving");
        var deviceModel = {};
        var hardware = "";
        var packageList = [];
        var moduleList = [];
        scope.errorMsg = [];

        // 1. Check current installation status.
        function checkInstallations(serialNumber) {
          return installationsService
            .getInstallations(null, null, null, serialNumber)
            .then(function (installation) {
              if (!!installation.data && installation.data.length > 0) {
                scope.errorMsg = gettextCatalog.getString("Device " + serialNumber + " has already been activated.");
                handleError();
              } else {
                getDevice(serialNumber);
              }
            }, function (error) {
              scope.errorMsg = gettextCatalog.getString("Could not verify the installation status for device " + serialNumber);
              handleError();
            });
        }

        // 2. Get the device by serial number.
        function getDevice(serialNumber) {
          return devicesService.getDevice(serialNumber)
            .then(function (deviceResponse) {
              deviceModel = deviceResponse.data;
              if (deviceResponse.data) {
                deviceModel = deviceResponse.data;
                scope.$emit("deviceRetrieved", {
                  device: deviceModel
                });
                getDeviceModel(serialNumber);
              }
              return serialNumber;
            }, function (error) {
              scope.errorMsg = gettextCatalog.getString("Device " + serialNumber + " could not be found, Please enter a valid serial number");
              handleError();
            });
        }

        // 3. Get Device Model
        function getDeviceModel(serialNumber) {
          return devicesService.getDeviceModelBySerialNumber(serialNumber).then(function (response) {
            hardware = response.data.name;
            getPackages();

          }, handleError);
        }


        // 3. Get the packages.
        function getPackages() {
          return packagesService
            .getAllPackages()
            .then(function (packageResponse) {
              packageList = [];
              moduleList = [];
              if (!!packageResponse && !!packageResponse.data) {
                for (var i = 0; i < packageResponse.data.length; i++) {
                  var pkg = packageResponse.data[i];
                  if (!pkg.inactive && pkg.hardware.indexOf(hardware) >= 0) {
                    if (pkg.isModule) {
                      moduleList.push(pkg);
                      continue;
                    }
                    packageList.push(pkg);
                  }
                }
                scope.$emit("packagesRetrieved", {
                  packages: packageList,
                  modules: moduleList
                });
              }

              deferred.resolve();
            }, function (error) {
              scope.errorMsg = gettextCatalog.getString("Could not retrieve packages for device " + serialNumber);
              handleError();
            });
        }

        // Handle any error.
        function handleError(error) {
          scope.$emit("errorsRetrieved", {
            errorMessage: scope.errorMsg
          });
        }

        // Execute the process.
        checkInstallations(serialNumber);

        return deferred.promise;
      };
    }
  };
}